import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }

import Api from '@/services/api';
    import { ElForm, ElInput } from 'element-plus';
    import { ref } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MessageView',
  setup(__props) {

    const message = ref<string>('')
    const loading = ref<boolean>(false)

    const send = async () => {
        loading.value = true
        try {
            const res = await Api.post('/admin/send-message', {message: message.value})
            console.log(res)
            alert("Mensagem enviada a todos usuarios")
        } catch(e) {
            alert("Ocorreu um erro")
        } finally {
            loading.value = false
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Enviar Mensagem a todos clientes" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElForm), { "label-position": "top" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Mensagem a enviar",
              prop: "description"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  type: "textarea",
                  name: "message",
                  modelValue: message.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event)),
                  minlength: 1,
                  maxlength: 300,
                  placeholder: "Escreva a mensagem",
                  rows: 7,
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ElButton, {
              disabled: message.value.trim().length <= 0 || loading.value,
              loading: loading.value,
              onClick: send
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" Enviar mensagem ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})